import { Link, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import { LoadingBlock } from './components/Feedback';
import { Layout } from './components/Layout';
import { CatalogPage } from './pages/Catalog';
import { ClientDetailPage } from './pages/ClientDetail';
import { ClientsPage } from './pages/Clients';
import { DashboardPage } from './pages/Dashboard';
import { LoginPage } from './pages/Login';
import { LogsPage } from './pages/Logs';
import { NumbersPage } from './pages/Numbers';
import { PoolPage } from './pages/Pool';
import { PricingPage } from './pages/Pricing';
import { PurchasesPage } from './pages/Purchases';
import { QueuePage } from './pages/Queue';
import { SettingsPage } from './pages/Settings';
import { UpstreamPage } from './pages/Upstream';

function RequireAuth() {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <LoadingBlock label="Проверка сессии…" />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

function NotFoundPage() {
  return (
    <div className="grid place-items-center py-16 text-center">
      <div className="space-y-2">
        <div className="text-2xl font-semibold text-zinc-100">404</div>
        <p className="text-sm text-zinc-500">Такой страницы нет.</p>
        <Link to="/" className="text-sm text-sky-400 hover:underline">
          На главную
        </Link>
      </div>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="queue" element={<QueuePage />} />
          <Route path="purchases" element={<PurchasesPage />} />
          <Route path="numbers" element={<NumbersPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="clients/:id" element={<ClientDetailPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="catalog" element={<CatalogPage />} />
          <Route path="pool" element={<PoolPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="upstream" element={<UpstreamPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
